export default {
  'buttons.learnMore': 'Learn more',
  'buttons.getStarted': 'Get started',
  'buttons.contact': 'Contact us',
  'buttons.demo': 'Request a demo',
  'buttons.consult': 'Consult now',
  'buttons.getDemoSolution': 'Get demo solution',
  'navigation.home': 'Home',
  'navigation.products': 'Products',
  'navigation.products.worktool': 'WorkTool Assistant',
  'navigation.products.chatlink': 'ChatLink Q&A',
  'navigation.products.outbound': 'Outbound Robot',
  'navigation.products.huitianAi': 'Huitian AI',
  'navigation.products.mcp': 'MCP Filesystem',
  'navigation.products.aiGateway': 'AI Gateway',
  'navigation.cases': 'Cases',
  'navigation.private': 'Private Deploy',
  'navigation.about': 'About',
  'navigation.pricing': 'Pricing',
  'navigation.contact': 'Contact',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  confirm: 'Confirm',
  cancel: 'Cancel',
};
